import CSS from "csstype";
import React from "react";

type AddBotProps = {
  disabled: boolean;
  addBot: () => void;
};

export const AddBot: React.FC<AddBotProps> = ({ disabled, addBot }) => {
  if (disabled) {
    return null;
  }

  return (
    <div style={addBotStyle} onClick={addBot}>
      add bot
    </div>
  );
};

const addBotStyle: CSS.Properties = {
  position: "relative",
  textAlign: "center",
  cursor: "pointer",
};
